const appendScript = (scriptToAppend) => {
  console.log(`Appending script: ${scriptToAppend}`);
  const script = document.createElement("script");
  script.src = scriptToAppend;
  script.async = false;
  document.body.appendChild(script);
};

export default appendScript;
export const showNoInternetPop = () => {
  let notification = document.getElementById("nointernetmodal");
  notification.style.display = "block";
  document
    .getElementById("closeInternetModal")
    .addEventListener("click", function () {
      notification.style.display = "none";
    });
};
